import React from 'react';
import { Platform } from 'react-native';

/**
 * Icon size tokens
 * - inline: 16px - For icons inline with text
 * - button: 20px - For icons inside buttons
 * - standalone: 24px - For standalone icons
 */
export const ICON_SIZES = {
  inline: 16,
  button: 20,
  standalone: 24,
};

/**
 * Icon weight tokens
 * - light: 1.5px stroke
 * - regular: 2px stroke (default)
 */
export const ICON_WEIGHTS = {
  light: 'light',
  regular: 'regular',
};

/**
 * Icon component wrapper with design system tokens.
 *
 * @param {Object} props
 * @param {React.ComponentType} props.icon - Phosphor icon component
 * @param {string|number} props.size - Size token ('inline', 'button', 'standalone') or number
 * @param {string} props.weight - Phosphor weight ('light', 'regular', 'bold', etc.)
 * @param {string} props.color - Icon color
 * @param {string} props.accessibilityLabel - Accessibility label for screen readers
 */
const Icon = ({
  icon: IconComponent,
  size = 'inline',
  weight = 'regular',
  color,
  accessibilityLabel,
  style,
  ...props
}) => {
  const sizeValue = typeof size === 'number' ? size : ICON_SIZES[size] || ICON_SIZES.inline;

  const accessibilityProps = Platform.OS === 'web'
    ? { 'aria-label': accessibilityLabel, role: accessibilityLabel ? 'img' : undefined }
    : { accessibilityLabel };

  return (
    <IconComponent
      size={sizeValue}
      weight={weight}
      color={color}
      style={style}
      {...accessibilityProps}
      {...props}
    />
  );
};

export default Icon;
